import React from "react";
import { TextField, Box } from "@mui/material";

const CustomInput = ({
  type = "text",
  name,
  label,
  value,
  onChange,
  required = false,
  error = false,
  helperText = "",
  multiline = false,
  rows = 4,
  size = "small",
  fullWidth = true,
  disabled = false,
  placeholder = "",
  InputProps = {},
  InputLabelProps = {},
  ...props
}) => {
  return (
    <Box sx={{ width: fullWidth ? "100%" : "auto" }}>
      <TextField
        type={type}
        name={name}
        label={label}
        value={value || ""}
        onChange={onChange}
        required={required}
        error={error}
        disabled={disabled}
        multiline={multiline}
        rows={multiline ? rows : 1}
        fullWidth={fullWidth}
        variant="outlined"
        size={size}
        placeholder={placeholder}
        helperText={error ? helperText : ""}
        InputLabelProps={{
          shrink: true,
          ...InputLabelProps,
        }}
        InputProps={InputProps}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: "8px",
            backgroundColor: disabled ? "#f1f5f9" : "#ffffff",
            transition: "all 0.2s ease",
            '& fieldset': {
              borderColor: error ? "#dc2626" : "#e2e8f0",
              borderWidth: error ? "2px" : "1.5px",
            },
            '&:hover fieldset': {
              borderColor: error ? "#dc2626" : "#94a3b8",
              borderWidth: error ? "2px" : "1.5px",
            },
            '&.Mui-focused fieldset': {
              borderColor: error ? "#dc2626" : "#64748b",
              borderWidth: "2px",
              boxShadow: error 
                ? "0 0 0 3px rgba(220, 38, 38, 0.1)" 
                : "0 0 0 3px rgba(100, 116, 139, 0.1)",
            },
          },
          '& .MuiInputLabel-root': {
            fontSize: "0.85rem",
            color: "#64748b",
            fontWeight: 500,
            '&.Mui-focused': {
              color: "#475569",
            },
            '&.Mui-error': {
              color: "#dc2626",
            },
          },
          '& .MuiInputBase-input': {
            fontSize: "0.875rem",
            fontWeight: 500,
            color: "#1e293b",
            padding: "10px 14px",
            '&::placeholder': {
              color: "#94a3b8",
              fontWeight: 400,
              opacity: 1,
            },
          },
          '& .MuiInputBase-inputMultiline': {
            padding: "10px 14px",
            minHeight: "60px",
          },
          '& .MuiFormHelperText-root': {
            fontSize: "0.75rem",
            fontWeight: 500,
            marginLeft: 0,
            marginTop: "4px",
            color: error ? "#dc2626" : "#94a3b8",
          },
        }}
        {...props}
      />
    </Box>
  );
};

export default CustomInput;